// All configurable values live in SystemConfig DB — NOT here.
// This file contains only truly immutable constants.

export const APP_NAME = 'Shahira Lasheen ERP';
export const APP_VERSION = '2.0.0';

// Pagination defaults (overridable via SystemConfig)
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

// Date formats
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DISPLAY_DATE_FORMAT = 'DD MMM YYYY';
export const DISPLAY_DATETIME_FORMAT = 'DD MMM YYYY HH:mm';

// Currency
export const BASE_CURRENCY_CODE = 'EGP';
export const DECIMAL_PRECISION_MONETARY = 2;
export const DECIMAL_PRECISION_QUANTITY = 2;
export const DECIMAL_PRECISION_RATE = 6;

// Module colors (for source badges)
export const MODULE_COLORS: Record<string, string> = {
  purchasing: '#1890ff',
  crm: '#52c41a',
  inventory: '#722ed1',
  accounting: '#fa8c16',
  calendar: '#eb2f96',
  manufacturing: '#13c2c2',
  projects: '#2f54eb',
  rnd: '#a0d911',
  marketing: '#f5222d',
  hr: '#faad14',
} as const;

// Correction chain
export const CORRECTION_CODE_PREFIX = 'CORR';
